import React from 'react';
import { ListItem, ListItemText, Typography, ListItemSecondaryAction } from '@mui/material';
import Link from 'react-router-dom/Link';
import { get } from 'global/lib/lodash';
import moment from 'moment';
import { getStatus } from 'global/utils/edition';
import { uppercaseFirstAll } from 'global/utils';
import useStyles from './Edition.styles';

export function EditionListItem(props) {
  const classes = useStyles();
  const { item } = props;

  const content = {
    ...item,
    id: get(item, 'id', ''),
    title: get(item, 'name', ''),
    modifiedDate: moment(get(item, 'createdAt')).format('L'),
    status: getStatus(item),
  };

  return (
    <ListItem component={props.onClick ? undefined : Link} to={`/library/${content.id}`} button onClick={props.onClick ? (e) => props.onClick(content, e) : undefined} key={content.id}>
      <ListItemText
        classes={{
          primary: classes.bold,
        }}
        primary={content.title}
        secondaryTypographyProps={{ component: 'div' }}
        secondary={<Typography>{content.modifiedDate}</Typography>}
      />
      <ListItemSecondaryAction>
        <Typography className={classes.bold}>{`${uppercaseFirstAll(content.status.title)}`}</Typography>
      </ListItemSecondaryAction>
    </ListItem>
  );
}
